import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBigFlower = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 303,
	height: 161,
	viewBox: "0 0 303 161",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_dddd_2193_9765)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M82.1503 198.244C81.9064 198.019 81.6438 197.794 81.3812 197.588C78.1922 194.924 74.4029 192.954 70.2572 191.885C67.9687 191.303 65.5863 190.985 63.1289 190.985H53.6182C50.2792 190.985 47.0902 190.422 44.1075 189.353C38.5737 187.402 33.809 183.781 30.4324 179.091C29.8884 178.322 29.3631 177.534 28.8942 176.709C28.0313 175.208 27.2809 173.614 26.6994 171.944C25.6489 168.98 25.0674 165.773 25.0674 162.434C25.0674 159.095 25.6489 155.906 26.6994 152.923C29.5695 144.819 35.985 138.385 44.1075 135.534C47.0902 134.483 50.2792 133.902 53.6182 133.902C56.9573 133.902 60.1463 134.483 63.1289 135.534C65.6989 136.434 68.1 137.691 70.2572 139.267C74.9469 142.643 78.5674 147.389 80.5183 152.942C81.5688 155.924 82.1503 159.113 82.1503 162.452V198.263V198.244Z",
				fill: "#FF375B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M97.626 49.3373C97.776 49.1684 97.9449 48.9809 98.0949 48.7933C99.9708 46.5422 101.359 43.8785 102.109 40.9709C102.522 39.3576 102.747 37.6881 102.747 35.9435V29.2466C102.747 26.9018 103.141 24.6507 103.891 22.5498C105.261 18.6479 107.831 15.2901 111.114 12.9265C111.658 12.5326 112.22 12.1762 112.783 11.8385C113.834 11.2195 114.959 10.713 116.141 10.3003C118.242 9.5687 120.493 9.15601 122.838 9.15601C125.183 9.15601 127.434 9.5687 129.535 10.3003C135.237 12.3262 139.777 16.8471 141.784 22.5498C142.534 24.6507 142.928 26.9018 142.928 29.2466C142.928 31.5915 142.516 33.8425 141.784 35.9435C141.146 37.7444 140.265 39.4326 139.158 40.9709C136.776 44.2724 133.436 46.8236 129.535 48.193C127.434 48.9246 125.183 49.3373 122.838 49.3373H97.626Z",
				fill: "#FFF3EB"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M97.626 198.245C98.17 197.757 98.714 197.27 99.2955 196.819C106.18 191.098 114.34 186.821 123.25 184.532C128.165 183.257 133.324 182.581 138.633 182.581H159.136C166.321 182.581 173.224 181.343 179.639 179.074C191.589 174.853 201.831 167.049 209.109 156.957C210.291 155.306 211.398 153.599 212.43 151.817C214.305 148.572 215.9 145.158 217.157 141.556C219.427 135.159 220.665 128.237 220.665 121.053C220.665 113.868 219.427 106.965 217.157 100.549C210.985 83.0662 197.122 69.2222 179.658 63.0506C173.243 60.7808 166.339 59.5427 159.155 59.5427C151.97 59.5427 145.067 60.7808 138.651 63.0506C133.118 65.0015 127.94 67.7215 123.269 71.0794C113.177 78.3578 105.355 88.6 101.153 100.549C98.8828 106.965 97.6447 113.868 97.6447 121.053V198.226L97.626 198.245Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.1507 118.051C81.7755 117.639 81.4004 117.207 81.0439 116.776C76.6356 111.486 73.3716 105.22 71.6083 98.3735C70.6328 94.603 70.1076 90.6449 70.1076 86.5555V70.8169C70.1076 65.3018 69.1696 59.9931 67.4251 55.0783C64.1798 45.9053 58.1958 38.0266 50.4296 32.4552C49.154 31.5361 47.8409 30.6919 46.4903 29.904C43.9954 28.4596 41.3692 27.2403 38.6116 26.2648C33.6968 24.5203 28.3881 23.5823 22.873 23.5823C17.3579 23.5823 12.0492 24.539 7.13443 26.2648C-6.27809 31.0108 -16.9143 41.647 -21.6603 55.0595C-23.3861 60.0118 -24.3428 65.3018 -24.3428 70.8169C-24.3428 76.332 -23.3861 81.6407 -21.6415 86.5555C-20.1408 90.795 -18.0586 94.7718 -15.4699 98.3735C-9.87977 106.121 -2.01985 112.124 7.15318 115.369C12.0867 117.114 17.3767 118.051 22.8918 118.051H82.1507Z",
				fill: "#FF9903"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_dddd_2193_9765",
		x: -29.3428,
		y: .156006,
		width: 332.008,
		height: 251.107,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 4,
				dy: 2
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2193_9765"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 14,
				dy: 7
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.04 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect1_dropShadow_2193_9765",
				result: "effect2_dropShadow_2193_9765"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 32,
				dy: 16
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.03 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect2_dropShadow_2193_9765",
				result: "effect3_dropShadow_2193_9765"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 57,
				dy: 28
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect3_dropShadow_2193_9765",
				result: "effect4_dropShadow_2193_9765"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect4_dropShadow_2193_9765",
				result: "shape"
			})
		]
	}) })]
});
export default SvgBigFlower;
